import { Helmet } from 'react-helmet-async';

const defaultSEO = {
  title: "Steward Healthcare India | NABH Consultancy & Digital Healthcare Solutions",
  description: "Leading healthcare consulting company offering NABH accreditation, digital healthcare solutions (CareO EMR/HIS), hospital planning, and healthcare courses. Serving 200+ facilities since 2016.",
  keywords: "NABH consultancy India, NABH accreditation, hospital accreditation, healthcare consulting, EMR software India, HIS software, NABL consultancy",
  image: "https://customer-assets.emergentagent.com/job_steward-health-hub/artifacts/1if4pbt1_steward.png"
};

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image,
  url,
  type = "website"
}) => {
  const seoTitle = title ? `${title} | Steward Healthcare India` : defaultSEO.title;
  const seoDescription = description || defaultSEO.description;
  const seoKeywords = keywords || defaultSEO.keywords;
  const seoImage = image || defaultSEO.image;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      
      {/* Twitter */}
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  );
};

export default SEO;
